<template>
	<form @submit.prevent="onSubmit">
		<v-card-title class="text-center justify-center">
			<h2>{{$t("pages.measurementRow.surveyAcceptance")}}</h2>
		</v-card-title>

		<v-card-text>
			<v-checkbox v-model="form.non_billable" label=" מדידה זו כלולה  כבר עם מדידה אחרת"/>
			<v-alert v-if="form.non_billable" type="warning">
				שים לב! מדידה זו לא תחוייב בתשלום! יש לשים לב שהמדידה הראשית אינה לא תסומן ככלולה עם מדידה אחרת
			</v-alert>
			<v-spacer/>
			<smart-input
				outlined
				:rows="4"
				:error="false"
				:required="form.non_billable"
				:textarea="true" name="reason"
				v-model="form.surveyor_notes"
				:label="$t('pages.orderTable.note')"/>

		</v-card-text>
		<v-card-title class="justify-center">
			<h5 class="justify-content-center"> {{$t("dialog.ok.text")}}</h5>
		</v-card-title>
		<v-card-actions class="text-center justify-center">
			<v-btn type="submit" :loading="onProgress" color="primary">{{$t("attributes.save")}}</v-btn>
			<v-btn type="button" @click="$emit('close')" color="error">{{$t("attributes.cancel")}}</v-btn>
		</v-card-actions>
	</form>
</template>

<script>
	import {types as statusTypes} from "dev/helpers/StatusManager";
	import {types as measurementTypes} from "dev/store/modules/Measurement.module";

	export default {
		name: "accept-form",
		props: {measurements: Array},
		components: {},
		data() {
			return {
				onProgress: false,
				form: {
					surveyor_notes: "",
					non_billable: false
				}
			};
		},
		computed: {},
		methods: {
			async onSubmit() {
				// this.item.non_billable = this.form.non_billable;
				// this.item.surveyor_notes = this.form.surveyor_notes;
				// this.item.status = statusTypes.DONE;
				// this.item.end_date = moment().format("YYYY-MM-DDTHH:mm:ss");
				this.onProgress = true;
				let data = {ids: this.measurements, ...this.form};
				await this.$store.dispatch(measurementTypes.DONE, data);
				this.onProgress = false;
				this.$emit("save");
				this.form = {
					surveyor_notes: "",
					non_billable: false
				};
			}
		},

	};
</script>

<style scoped>

</style>
